import { DialogForm, Form } from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MutateVirtualAtonFormValues } from './atonForm';
import {
  DrawingStyles,
  useDrawFromDialog,
  useDrawingContext,
} from '@ais-ui/react-openlayers';
import { MutateVirtualForm } from './MutateVirtualForm';
import { useLocalization } from '@ais-ui/locale-management';
import { useGetShareGroups } from '@ais-ui/websockets';

interface AtonDialogProps {
  form: UseFormReturn<MutateVirtualAtonFormValues>;
  onSubmit: (data: MutateVirtualAtonFormValues) => void;
  mutateType: 'edit' | 'create';
  isSubmitting: boolean;
  setShowOuterDialog: (showOuterDialog: boolean) => void;
}

export const AtonVirtualDialog = ({
  form,
  onSubmit,
  mutateType,
  isSubmitting,
  setShowOuterDialog,
}: AtonDialogProps) => {
  const { messages } = useLocalization();
  const dialogTitle =
    mutateType === 'create'
      ? messages.atonVirtualDialogCreateTitle
      : messages.atonVirtualDialogEditTitle;

  const [showDialog, setShowDialog] = useState<boolean>(true);
  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();

  const { showDrawPanel } = useDrawingContext();

  const { onStartDrawingFromDialog } = useDrawFromDialog(
    form,
    setShowDialog,
    'geometry',
    DrawingStyles.VirtualAton
  );

  const handleOpenChange = (isOpen: boolean) => {
    setShowDialog(isOpen); // Update showDialog state

    // Make sure that we are not unmounting the component when drawing, but we will unmount it if we are not drawing
    if (!showDrawPanel) {
      setShowOuterDialog(isOpen);
    }
  };

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={handleOpenChange}
        title={dialogTitle}
        isLoading={isLoadingGroups}
        hasLoaded={!isLoadingGroups && !!groups}
        buttonId="submit-virtual-aton-button"
        buttonText={
          isSubmitting ? messages.genericSubmitting : messages.genericSubmit
        }
        buttonDisabled={isSubmitting}
        buttonOnClick={form.handleSubmit(onSubmit)}
      >
        <MutateVirtualForm
          form={form}
          onStartDrawing={onStartDrawingFromDialog}
        ></MutateVirtualForm>
      </DialogForm>
    </Form>
  );
};
